import React from 'react';
export const Avatar = ({
  name = 'User',
  backgroundColor = '#007bff',
  size = 50,
}) => {
  // Function to get initials from the name prop
  const getInitials = (name: string): string => {
    if (!name) return '';
    const nameParts = name.split(' ');
    const initials = nameParts
      .map((part) => part.charAt(0).toUpperCase())
      .slice(0, 2) // Limit to 2 initials
      .join('');
    return initials;
  };

  return (
    <div
      style={{
        backgroundColor,
        color: '#fff',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size / 2,
        width: size,
        height: size,
        fontWeight: 'bold',
        textTransform: 'uppercase',
      }}
    >
      {getInitials(name)}
    </div>
  );
};
